export default __webpack_public_path__ + "static/media/cards-small.9cbbec96.svg";